@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText" />
}
<div
    class="option-group-container correct-score-container score-options"
    [style.--option-group-groups]="scoreRowsCount()"
    [class.us-correct-score]="isUSCorrectScoreTemplate()"
    [ngClass]="scoreOptionsClass()">
    <div class="option-group-header">
        @for (name of headerNames(); track $index) {
            <span>{{ name }}</span>
        }
    </div>
    <ng-container
        *rxFor="let option of scoreOptions$; trackBy: trackOption; strategy: renderStrategy$; renderCallback: groupsRendered$; let i = index">
        @if (option) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: { option }" />
        } @else {
            <div class="option option-placeholder" [class.option-placeholder-shadow]="isPlaceholderShadowVisible(i)"></div>
        }
    </ng-container>
</div>

<div class="option-group-container correct-score-container single">
    <ng-container *rxFor="let option of restOptions$; trackBy: trackOption">
        <ng-container *ngTemplateOutlet="optionTemplate; context: { option }" />
    </ng-container>

    <ng-container *msShowInEpcot="false">
        @if (!showAllOptions()) {
            <div class="more" (click)="expand()">
                @if (isCollapsed()) {
                    <span class="collapsed">{{ this.sitecore.event.ShowMore }} <vn-icon size="12" name="theme-down" /> </span>
                } @else {
                    <span class="expanded">{{ this.sitecore.event.ShowLess }} <vn-icon size="12" name="theme-up" /> </span>
                }
            </div>
        }
    </ng-container>
</div>

<ng-container *msShowInEpcot="true">
    @if (!showAllOptions()) {
        <div class="show-more-less-button" [ngClass]="{ expanded: !isCollapsed() }" (click)="expand()">
            {{ isCollapsed() ? this.sitecore.event.ShowMore : this.sitecore.event.ShowLess }}
            <span class="right-icon"><vn-icon name="theme-right" size="12" /></span>
        </div>
    }
</ng-container>

<ng-template #optionTemplate let-option="option">
    <ms-option
        [tracking]="{ source: tracking, moduleType: trackingModuleType }"
        [option]="option"
        [optionGroup]="optionGroup()"
        [event]="event"
        [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]"
        [sourceOfPick]="sourceOfPick"
        [betDetails]="betDetails"
        [customOptionNameTemplate]="isUSCorrectScoreTemplate() ? usCorrectScoreOptionName : null" />
</ng-template>

<ng-template #usCorrectScoreOptionName let-option="option">
    {{ option | msCorrectScoreOptionName }}
</ng-template>
